import { useQuery, useQueryClient } from '@tanstack/react-query';
import { fetchLeadCategories } from '@/data/lead-categories';
import type { LeadCategoryList } from '@/data/leads-model';

/* The active workspace's lead-category list (names, archive/merge state, counts,
 * whether manual edits are enabled). Shared by the Leads filter, chips, the edit
 * picker and Settings › Lead categories; a mutation calls `replace(list)` with the
 * fresh list the server returns and invalidates the lead lists (names/merges change
 * what every lead reads). */
export const LEAD_CATEGORIES_KEY = ['lead-categories'] as const;

export function useLeadCategories() {
  const qc = useQueryClient();
  const query = useQuery({ queryKey: LEAD_CATEGORIES_KEY, queryFn: fetchLeadCategories, staleTime: 60_000, retry: 1 });
  const replace = (list: LeadCategoryList) => {
    qc.setQueryData(LEAD_CATEGORIES_KEY, list);
    void qc.invalidateQueries({ queryKey: ['leads-page'] });
    void qc.invalidateQueries({ queryKey: ['lead-full'] });
  };
  return { list: query.data ?? null, isLoading: query.isPending, error: query.error, refetch: query.refetch, replace };
}
